import { render, staticRenderFns } from "./cuttingBatchPage.vue?vue&type=template&id=927346b6&scoped=true&"
import script from "./cuttingBatchPage.vue?vue&type=script&lang=js&"
export * from "./cuttingBatchPage.vue?vue&type=script&lang=js&"
import style0 from "./cuttingBatchPage.vue?vue&type=style&index=0&id=927346b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927346b6",
  null
  
)

export default component.exports